import React from 'react';
import { Note } from '../types';
import { NOTE_COLORS } from '../constants';
import { StarIcon } from './Icons';

interface NoteCardProps {
  note: Note;
  onClick: (note: Note) => void;
  onToggleFavorite: (e: React.MouseEvent, note: Note) => void;
}

const NoteCard: React.FC<NoteCardProps> = ({ note, onClick, onToggleFavorite }) => {
  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
  };

  return (
    <div 
      onClick={() => onClick(note)}
      className={`
        relative group cursor-pointer 
        ${NOTE_COLORS[note.color]} 
        rounded-2xl p-6 
        shadow-sm hover:shadow-lg transition-all duration-300 ease-out
        border border-gray-100 hover:border-gray-200 hover:-translate-y-1
        flex flex-col h-64
      `}
    >
      <div className="flex justify-between items-start mb-3">
        <h3 className="font-semibold text-lg text-gray-900 truncate pr-6 w-full">
          {note.title || <span className="text-gray-400 italic">Untitled Note</span>}
        </h3>
        <button 
          onClick={(e) => onToggleFavorite(e, note)}
          className={`
            absolute top-6 right-6 p-1 rounded-full transition-colors 
            ${note.isFavorite ? 'text-yellow-500 opacity-100' : 'text-gray-400 opacity-0 group-hover:opacity-100 hover:text-gray-600'}
          `}
        >
          <StarIcon size={18} filled={note.isFavorite} />
        </button>
      </div>
      
      <p className="text-gray-600 text-sm leading-relaxed overflow-hidden flex-grow line-clamp-6">
        {note.content || "No content..."}
      </p>
      
      <div className="mt-4 pt-4 border-t border-black/5 text-xs text-gray-400 flex justify-between items-center">
        <span>{formatDate(note.updatedAt)}</span>
      </div>
    </div>
  );
};

export default NoteCard;
